/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Deactivateaccounttitlev23Inputs */

const en_settings_deactivateaccounttitlev23 = /** @type {(inputs: Settings_Deactivateaccounttitlev23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deactivation`)
};

/**
* | output |
* | --- |
* | "Deactivation" |
*
* @param {Settings_Deactivateaccounttitlev23Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_deactivateaccounttitlev23 = /** @type {((inputs?: Settings_Deactivateaccounttitlev23Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Deactivateaccounttitlev23Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_deactivateaccounttitlev23(inputs)
});
export { settings_deactivateaccounttitlev23 as "settings_deactivateAccountTitleV2" }